import { createStyles, makeStyles } from "@material-ui/styles";
import {
    Attachment,
    Button,
    DownloadIcon,
    RelodeTheme,
    Text,
} from "@relode/core";
import * as React from "react";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                display: "flex",
                alignItems: "center",
                width: "100%",
                flexDirection: "column",
                justifyContent: "center",
                height: "100%",
            },
            info: {
                padding: theme.spacing(3),
                textAlign: "center",
            },
            noResults: {
                padding: theme.spacing(3),
                textAlign: "center",
            },
            downloadButton: {
                width: 180,
            },
            downloadIcon: {
                marginRight: theme.spacing(1),
            },
        }),
    { name: "CandidateResumeMobile" }
);

interface CandidateResumeMobileProps {
    resume?: Attachment;
}
export const CandidateResumeMobile = (props: CandidateResumeMobileProps) => {
    const classes = useStyles({});
    const { resume } = props;
    const baseId = "CandidateResumeMobile";

    const handleOpen = () => {
        window.open(resume.fileUri);
    };

    return (
        <div className={classes.root} id={baseId}>
            {resume ? (
                <>
                    <div className={classes.info}>
                        <Text variant="body1">
                            download resume on your mobile
                        </Text>
                    </div>
                    <Button
                        size="small"
                        variant="contained"
                        className={classes.downloadButton}
                        onClick={handleOpen}
                        title="download formatted resume"
                    >
                        <DownloadIcon
                            color="inherit"
                            className={classes.downloadIcon}
                        />
                        open resume
                    </Button>
                </>
            ) : (
                <Text
                    variant="h4"
                    color="primary"
                    className={classes.noResults}
                >
                    Resume not available.
                    <br />
                    Please contact your Job Manager.
                </Text>
            )}
        </div>
    );
};
